module.exports = __webpack_public_path__ + "img/sui-small-dark.330677c5.svg";